/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_MatchBrandSortTime = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchBrandSortTime.prototype = {
    /* The view object name */
    name: 'matchBrand',
    /* The view object instance */
    view: {
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'userVisitBrandMatch',
            basePath: '',
            rule: {
                brandId: 'matchBrandId'
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    /**
     * @private
     * Format the organization position field according to the given fields.
     */
}

module.exports = tbs_model_vo_MatchBrandSortTime